module.exports = __webpack_public_path__ + "img/network.a15711fd.svg";